// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"383":"manage","408":"song","443":"about","449":"notFound"}[chunkId] || chunkId) + "." + {"208":"65d094f4","383":"976853ac","408":"dd85cb96","416":"330bacb8","443":"48a9527f","449":"7b85836e","490":"7619dfb1","663":"bdff7374"}[chunkId] + ".js";
};